
/* eslint-disable global-require */
const Main = r => require.ensure([], () => r(require('./Main')), 'packages-bundle')
const Form = r => require.ensure([], () => r(require('./Form')), 'packages-bundle')

export default [
  {
    name: 'packages.group',
    path: 'group',
    component: Main,
    meta: { requiresAuth: true },
    children: [
      {
        name: 'packages.group.new',
        path: 'create',
        component: Form
      },
      {
        name: 'packages.group.edit',
        path: ':id/edit',
        component: Form
      }
    ]
  }
]



// WEBPACK FOOTER //
// ./src/app/packages/group/routes.js